/*
*
* File JS componente Readmore
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './readmore.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const readmore = () => {
    let readmoreCta = document.querySelectorAll('.readmore__cta');

    if (!readmoreCta.length) return;

    readmoreCta.forEach(el => {
        let id = el.dataset.readmore;

        let content = document.querySelector(`.readmore__content[data-readmore="${id}"]`);
        let textOpen = el.dataset.readmoreTextOpen;
        let textClose = el.dataset.readmoreTextClose;

        el.addEventListener('click', () => {
            
            if (!content.classList.contains('active'))
            {
                jQuery(content).slideDown();
                content.classList.add('active');
                el.classList.add('active');
                el.querySelector('.text').innerHTML = textOpen;
            }
            else
            {
                jQuery(content).slideUp();
                content.classList.remove('active');
                el.classList.remove('active');
                el.querySelector('.text').innerHTML = textClose;
            }

        });
    });
}

export default readmore;

//--------------------------------------------------------------------//